import Model, { attr, belongsTo } from '@ember-data/model';

export default class PermisoGrupoModel extends Model {
  @attr('string') codigo;

  @attr('string') nombre;

  @attr('number') orden;

  @belongsTo('permiso-grupo', { async: false, inverse: null }) superior;
}
